/**
 * Animation class
 */
export default class Ani {
    static async fadeOut(element) {
        element.classList.add('opacity-0');
        element.classList.add('pointer-events-none');
        element.classList.remove('opacity-100');
        element.classList.remove('pointer-events-auto');
        await this.sleepAnimation(element);
        return;
    }

    static async fadeIn(e) {
        e.classList.remove('opacity-0', 'pointer-events-none');
        e.classList.add('opacity-100');
        e.classList.add('pointer-events-auto');
        await this.sleepAnimation(e);
        return;
    }

    static async fadeOutText(element) {
        element.classList.add('text-opacity-0');
        await this.sleepAnimation(element);
        return;
    }

    static async fadeInText(element) {
        element.classList.remove('text-opacity-0');
        await this.sleepAnimation(element);
        return;
    }

    static async hide(element) {
        element.classList.add('hidden');
        return;
    }

    static async unHide(element) {
        element.classList.remove('hidden');
        return;
    }

    static async toggleHidden(element) {
        element.classList.toggle('hidden');
        return;
    }

    static async disableScroll() {
        document.body.classList.add('overflow-hidden');
        return;
    }

    static async enableScroll() {
        document.body.classList.remove('overflow-hidden');
        return;
    }

    static async sleepAnimation(element) {
        return await this.sleep(this.getAnimationDuration(element));
    }

    static getAnimationDuration(element) {
        const durationClass = [...element.classList].find((item) => item.includes('duration'));
        if (!durationClass) {
            return 0;
        }
        return durationClass.replace('duration-', '');
    }

    static async sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
}
